import { put, takeEvery } from 'redux-saga/effects';
import {
  appNotify,
  setSelectedModuleId,
  setSelectedModule,
  setSelectedModuleIsOpen,
  setGroupsAreLoading,
} from '../../../store/actions';
import { getWithToken } from '../../../api/network';

export function* getAssumptionModuleSaga() {
  yield takeEvery(setSelectedModuleId, function* ({ payload }) {
    try {
      if (!payload.selectedModuleId) {
        yield put(setSelectedModule(null));
        return;
      }

      yield put(setGroupsAreLoading(true));

      const url = `/api/assumptions/modules/${payload.selectedModuleId}`;
      const res = yield getWithToken(url);
      const data = yield res.json();

      yield put(setSelectedModule(data));
      yield put(setSelectedModuleIsOpen(true));
      yield put(setGroupsAreLoading(false));
    } catch (error) {
      yield put(
        appNotify(
          `Failure in getAssumptionModuleSaga: ${error.message}`,
          'error'
        )
      );
      yield put(setGroupsAreLoading(false));
    }
  });
}
